import { render, staticRenderFns } from "./OfferItem.vue?vue&type=template&id=dabc0c28&scoped=true&"
import script from "./OfferItem.vue?vue&type=script&lang=ts&"
export * from "./OfferItem.vue?vue&type=script&lang=ts&"
import style0 from "./OfferItem.vue?vue&type=style&index=0&id=dabc0c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabc0c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dabc0c28')) {
      api.createRecord('dabc0c28', component.options)
    } else {
      api.reload('dabc0c28', component.options)
    }
    module.hot.accept("./OfferItem.vue?vue&type=template&id=dabc0c28&scoped=true&", function () {
      api.rerender('dabc0c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/OfferItem.vue"
export default component.exports